import { ButtonProps } from './types';

import * as S from './styles';

const Button: React.FC<ButtonProps> = ({
  loading,
  disabled,
  children,
  ...props
}) => (
  <S.Button disabled={disabled || loading} {...props}>
    {loading ? <S.Spinner /> : children}
  </S.Button>
);

const OutlineButton: React.FC<ButtonProps> = ({
  loading,
  disabled,
  children,
  ...props
}) => (
  <S.OutlineButton disabled={disabled || loading} {...props}>
    {loading ? <S.Spinner /> : children}
  </S.OutlineButton>
);

export { Button, OutlineButton };
